module.exports = __webpack_public_path__ + "site/img/53.db0dea21.jpg";